import { render, staticRenderFns } from "./TheCallHistoryItem.vue?vue&type=template&id=4706e1f4&scoped=true"
import script from "./TheCallHistoryItem.vue?vue&type=script&lang=js"
export * from "./TheCallHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./TheCallHistoryItem.vue?vue&type=style&index=0&id=4706e1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706e1f4",
  null
  
)

export default component.exports